import { MIXIN_PAGE_DETAIL } from '@/mixins/page/mixinPageDetail'

export const MIXIN_PTO_PROJECT_PAGE_UPDATE = {
  mixins: [MIXIN_PAGE_DETAIL],

  data: () => ({
    // массив с именами справочников для запроса при маунте страницы
    // имя справочника с заглавной буквы
    handbooks: []
  }),

  async mounted () {
    // from vuex
    await Promise.all([
      this.loadOneItem(this.$route.params.id),
      this.handbooks.map(name => this.$store.dispatch(`handbook/pto/GET${name}List`))
    ])
  }
}
